var _dec, _class;

import { model, Model, prop } from "mobx-keystone";
export let GesturePointModel = (_dec = model("combat/PatternPointModel"), _dec(_class = class GesturePointModel extends Model({
  x: prop(0).withSetter(),
  y: prop(0).withSetter()
}) {}) || _class);